export enum RegistrationUserStatusEnum {
  PERSON_WITH_EXISTING_PROFILE = 'PERSON_WITH_EXISTING_PROFILE',
  PERSON_WITH_ACTIVE_POLICIES = 'PERSON_WITH_ACTIVE_POLICIES',
  PERSON_WITH_INACTIVE_POLICIES = 'PERSON_WITH_INACTIVE_POLICIES',
  PERSON_WITH_STALE_POLICIES = 'PERSON_WITH_STALE_POLICIES',
  PERSON_WITH_BLOCKED_POLICIES = 'PERSON_WITH_BLOCKED_POLICIES',
  PERSON_NOT_FOUND = 'PERSON_NOT_FOUND',
  SERVICE_FAILURE = 'SERVICE_FAILURE',
  PERSON_EXISTS = 'PERSON_EXISTS',
  PERSON_WITH_EXISTING_PROFILE_DIFF_EMAIL = 'PERSON_WITH_EXISTING_PROFILE_DIFF_EMAIL',
  CREATE_PERSON_ASSURANCE_LEVEL2 = 'CREATE_PERSON_ASSURANCE_LEVEL2',
  PERSON_WITH_SSN_REQUIRED = 'PERSON_WITH_SSN_REQUIRED',
  CREATE_PERSON_ASSURANCE_LEVEL3 = 'CREATE_PERSON_ASSURANCE_LEVEL3',
}
